import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';

export default function AuthCallback({ onAuth }) {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];

      if (!sessionId) {
        navigate('/', { replace: true });
        return;
      }

      try {
        const response = await fetch(
          'https://demobackend.emergentagent.com/auth/v1/env/oauth/session-data',
          { method: 'GET', headers: { 'X-Session-ID': sessionId } }
        );

        if (!response.ok) throw new Error('Failed to authenticate');

        const userData = await response.json();

        const backendResponse = await axios.post(`${API}/auth/google`, {
          email: userData.email,
          name: userData.name,
          picture: userData.picture,
          google_id: userData.id,
          session_token: userData.session_token
        });

        // Always go to dashboard after Google login
        // (user can complete profile from the profile page)
        const targetPath = '/dashboard';

        // Store token first
        localStorage.setItem('mojo_token', backendResponse.data.token);
        
        // Call onAuth to update React state  
        onAuth(backendResponse.data.token, backendResponse.data.user);

        // Use setTimeout to ensure React state update completes before navigation
        setTimeout(() => {
          window.history.replaceState(null, '', targetPath);
          navigate(targetPath, { replace: true });
        }, 100);

      } catch (error) {
        console.error('Auth callback error:', error?.response?.data || error?.message || error);
        // Clear hash to prevent retry loop
        window.history.replaceState(null, '', '/');
        // Small delay before redirect to let state settle
        setTimeout(() => navigate('/', { replace: true }), 200);
      }
    };

    processAuth();
  }, [navigate, onAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white via-stone-50 to-stone-100">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-hunter-green border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-warm-charcoal/70">Completing sign in...</p>
      </div>
    </div>
  );
}
